import { isNumber, round } from 'lodash-es';

export function toPercentage(cellData: any, layer: any) {
  if (!isNumber(cellData)) return '';
  const percentageNumber = round(cellData, 2);
  return `${percentageNumber}%`;
}
